import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState, useEffect } from 'react';
import { useMediaViewerListener } from './useMediaViewerListener';
import { useIframeVisibleHeight } from './useIframeVisibleHeight';
var MESSAGE_TYPE = 'contentSize';
export var useContentSize = function useContentSize() {
  // The initial height is arbitrarily set to 1000
  var _useState = useState(1000),
    _useState2 = _slicedToArray(_useState, 2),
    height = _useState2[0],
    setHeight = _useState2[1];

  /* This visible height refers to the portion of the confluence page that is visible within the iframe without having to scroll.
  	When isHeightSetFromContent is true, the embedded page container height toggles between the visible height and the content height
  	depending on whether media viewer is open or close.
  	This updated was added as a resolution to the bug explained in this ticket: https://hello.jira.atlassian.cloud/browse/CBT-3636
  */
  var _useMediaViewerListen = useMediaViewerListener(),
    isMediaOpen = _useMediaViewerListen.isMediaOpen;
  var _useIframeVisibleHeig = useIframeVisibleHeight(),
    visibleHeight = _useIframeVisibleHeig.visibleHeight;
  useEffect(function () {
    var contentSizeHandler = function contentSizeHandler(postMessage) {
      var data = postMessage.data;
      if ((data === null || data === void 0 ? void 0 : data.type) === MESSAGE_TYPE && data !== null && data !== void 0 && data.height) {
        setHeight(data.height);
      }
    };
    window.addEventListener('message', contentSizeHandler);
    return function () {
      window.removeEventListener('message', contentSizeHandler);
    };
  }, []);
  return {
    height: isMediaOpen ? visibleHeight : height
  };
};